
import React from 'react';
import DashboardCards from './DashboardCards';
import FinanceTable from './FinanceTable';


const FinanceTab = ({
  userData,
  outstandingPowerpoolBalance,
  workerFinance,
  poolData,
  k1PoolData,
  hashrates,
  workers,
  balances,
  earnings,
  activeWorkers,
  totalColor,
  isMobile,
  kasPrice,
  priceLoading,
  priceError,
  miningTotal,
  ledgerTotal,
  styles,
  formatNumber,
  getExpectedHashrate,
  timeUntilRefresh,
  formatTime,
  financeViewType,
  setFinanceViewType,
  financePriceType,
  setFinancePriceType,
  usdToGbpRate,
  getAllWorkers,
  usdToGbp,
  kasChange24h,
  usdcMiningBalance
}) => {
  return (
    <>
      <DashboardCards
        userData={userData}
        workerFinance={workerFinance}
        poolData={poolData}
        k1PoolData={k1PoolData}
        hashrates={hashrates}
        workers={workers}
        balances={balances}
        earnings={earnings}
        activeWorkers={activeWorkers}
        totalColor={totalColor}
        isMobile={isMobile}
        kasPrice={kasPrice}
        priceLoading={priceLoading}
        priceError={priceError}
        miningTotal={miningTotal}
        ledgerTotal={ledgerTotal}
        styles={styles}
        getExpectedHashrate={getExpectedHashrate}
        formatNumber={formatNumber}
        timeUntilRefresh={timeUntilRefresh}
        formatTime={formatTime}
        isFinanceTab={true}
        kasChange24h={kasChange24h}
        usdcMiningBalance={usdcMiningBalance}
      />
      <FinanceTable
        userData={userData}
        outstandingPowerpoolBalance={outstandingPowerpoolBalance}
        workerFinance={workerFinance}
        miningTotal={miningTotal}
        kasPrice={kasPrice}
        usdToGbpRate={usdToGbpRate}
        financeViewType={financeViewType}
        setFinanceViewType={setFinanceViewType}
        financePriceType={financePriceType}
        setFinancePriceType={setFinancePriceType}
        styles={styles}
        getAllWorkers={getAllWorkers}
        formatNumber={formatNumber}
        usdToGbp={usdToGbp}
      />
    </>
  );
};

export default FinanceTab;
